/*
 * @Description: 
 * @Author: ldy
 * @Date: 2019-07-22 10:12:09
 * @LastEditTime: 2020-04-02 13:14:04
 * @LastEditors: DOJO
 */
import Vue from 'vue'
import Router from 'vue-router'
import { eachRouter } from '../../common/js/Util'

Vue.use(Router)

const routes = [
  {
    path: '/index',
    name: 'index',
    meta: {
      title: '云集爆款招商'
    },
    component: () => import('./Index.vue')
  },
  {
    path: '/hotIndex',
    name: 'hotIndex',
    meta: {
      title: '云集爆款招商'
    },
    component: () => import('./Index.vue')
  },
  {
    path: '/message',
    name: 'message',
    meta: {
      title: '商品提报'
    },
    component: () => import('./pages/message.vue')
  }
]
// 路由正则处理，用于微信防封
eachRouter(routes)

export default new Router({
  mode: 'history',
  base: '/yunjiactivity/hotPage',
  routes: routes
})
